import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetEnums } from "../../../utilities";

const initialState = {
    Enums: [] as any
}

export const GetEnumsArr = createAsyncThunk("Enums/GetEnums", () => GetEnums())

const EnumsSlice = createSlice({
    name: "Enums",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(GetEnumsArr.fulfilled, (state, action: PayloadAction<any>) => {
                state.Enums = action.payload.data
            })

    }
})

export default EnumsSlice.reducer